import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { setFilter, summaryChartFilterSelector } from 'src/features'

const OverviewChartHeader: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const filter = useAppSelector(summaryChartFilterSelector)
  const widthSelect = filter === 7 ? '6.6' : filter === 30 ? '7' : '8'

  return <Select
    bordered={false}
    labelInValue={true}
    defaultValue={filter}
    style={{ width: `${widthSelect}rem` }}
    onChange={({ value }: any) => dispatch(setFilter(+value))}
  >
    <Select.Option value={7}>7 {t('Summary.Days')}</Select.Option>
    <Select.Option value={30}>30 {t('Summary.Days')}</Select.Option>
    <Select.Option value={365}>365 {t('Summary.Days')}</Select.Option>
  </Select>
}
export default OverviewChartHeader
